import { entities } from "../../contracts";
import { SelectionSide } from "../../data/enums/SelectionSide";
export const selectionOutcomeTypeMapper = {
    [entities.OutcomeType.Home]: SelectionSide.Home,
    [entities.OutcomeType.Away]: SelectionSide.Away,
    [entities.OutcomeType.Over]: SelectionSide.Home,
    [entities.OutcomeType.Under]: SelectionSide.Away,
    [entities.OutcomeType.Draw]: SelectionSide.Draw,
    [entities.OutcomeType.Tie]: SelectionSide.Draw,
};
//# sourceMappingURL=selectionOutcomeTypeMapper.js.map